export class ReservationModel {
    id: string;
    start: Date;
    end: Date;
    title: string;
    userid: string;
}


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/models/reservation.model.ts